import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useFocusStore } from '@/hooks/use-focus-store'
import { getCurrentFocus, navigateToThread } from '@/utils/thread-navigation'

export function useMemoryThreadNavigation(threadId?: string) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const { focus } = useFocusStore()

  const currentThreadParam = searchParams.get('thread')
  const isThreadOpen = Boolean(threadId && currentThreadParam === threadId)

  const openThread = (e?: React.MouseEvent) => {
    e?.stopPropagation()
    if (!threadId) return

    if (location.pathname === '/memories') {
      const params = new URLSearchParams(searchParams)
      params.set('thread', threadId)
      navigate(`/memories?${params.toString()}`)
    } else {
      const currentFocus = getCurrentFocus(focus, 'candidate')
      navigateToThread(navigate, threadId, currentFocus, true, searchParams)
    }
  }

  return { openThread, isThreadOpen }
}
